import { ValidationFailure } from "../../../errors/validation-failure";
import Guard from "../../../guard";
import { IRealtimeRequest } from "../realtime-request";

export class RealtimeValidator {
    validate(realtimeRequest: IRealtimeRequest): Array<ValidationFailure> {
        Guard.notNull(realtimeRequest);

        return [];
    }
}
